import React from 'react'
import ContainerPrint from './ContainerPrint'

const RowPrint = ({ rows, fullNameInContainer }) => {
  return (
    <div className="row-print-container">
      {Object.values(rows).map((containers, index) => {
        return (
          <ContainerPrint key={index} containers={containers} fullNameInContainer={fullNameInContainer} />
        )
      })}
    </div>
  )
}

export default RowPrint
